import clsx from "clsx";

interface SlideProps {
    clients: string[];
    direction?: "left" | "right";
}

const Slide: React.FC<SlideProps> = ({ clients, direction = "left" }) => {
    const loopedClients = [...clients, ...clients];
    const animationSpeedPerCard = 6;
    const duration = clients.length * animationSpeedPerCard;

    return (
        <div
            className={clsx("scroll-track", { right: direction === "right" })}
            style={{ animationDuration: `${duration}s` }}
        >
            {loopedClients.map((client, idx) => (
                <div key={`${client}-${idx}`} className="scroll-card">
                    <img
                        src={`/assets/clients/slide/${client}.png`}
                        alt="client"
                        width={215}
                        height={81}
                        style={{ height: "auto", maxWidth: "215px", width: "100%" }}
                    />
                </div>
            ))}
        </div>
    );
};

export { Slide };
